import { useTranslation } from 'react-i18next';
import { SystemErrorScreen } from '@/entities/system/ui';
import FailedStatusIcon from '@/shared/assets/failed-status-icon.svg?react';

type Props = {
  homeLink: '/' | '/login';
};

export const ErrorBoundary = ({ homeLink }: Props) => {
  const { t } = useTranslation();

  return (
    <SystemErrorScreen
      title={t('errorScreen.title')}
      description={t('errorScreen.description')}
      icon={FailedStatusIcon}
      homeLink={homeLink}
    />
  );
};
